export const idlFactory = ({ IDL }) => {
  const LLMEndpoint = IDL.Record({
    'url' : IDL.Text,
    'model_name' : IDL.Text,
    'name' : IDL.Text,
    'enabled' : IDL.Bool,
    'max_tokens' : IDL.Nat32,
    'timeout_seconds' : IDL.Nat32,
    'backend_type' : IDL.Text,
  });
  const ChatMessage = IDL.Record({ 'content' : IDL.Text, 'role' : IDL.Text });
  const ChatRequest = IDL.Record({
    'context' : IDL.Opt(IDL.Text),
    'messages' : IDL.Vec(ChatMessage),
    'conversation_id' : IDL.Opt(IDL.Text),
    'preferred_backend' : IDL.Opt(IDL.Text),
  });
  const ChatResponse = IDL.Record({
    'response_time_ms' : IDL.Nat64,
    'conversation_id' : IDL.Text,
    'tokens_used' : IDL.Nat32,
    'message' : IDL.Text,
    'backend_used' : IDL.Text,
  });
  const Result_ChatResponse = IDL.Variant({
    'Ok' : ChatResponse,
    'Err' : IDL.Text,
  });
  const Result_LLMEndpoints = IDL.Variant({
    'Ok' : IDL.Vec(LLMEndpoint),
    'Err' : IDL.Text,
  });
  const UsageStats = IDL.Record({
    'small_llm_queries' : IDL.Nat32,
    'total_queries' : IDL.Nat32,
    'large_llm_queries' : IDL.Nat32,
    'local_queries' : IDL.Nat32,
    'total_tokens' : IDL.Nat32,
  });
  return IDL.Service({
    'add_llm_endpoint' : IDL.Func([LLMEndpoint], [], []),
    'chat' : IDL.Func([ChatRequest], [Result_ChatResponse], []),
    'enable_llm_endpoint' : IDL.Func([IDL.Text, IDL.Bool], [], []),
    'get_admin_principal' : IDL.Func([], [IDL.Opt(IDL.Principal)], ['query']),
    'get_llm_endpoints' : IDL.Func([], [Result_LLMEndpoints], ['query']),
    'get_usage_statistics' : IDL.Func([], [UsageStats], ['query']),
    'is_configured' : IDL.Func([], [IDL.Bool], ['query']),
    'remove_llm_endpoint' : IDL.Func([IDL.Text], [], []),
    'set_admin' : IDL.Func([IDL.Principal], [], []),
    'set_discovery_doctor_principal' : IDL.Func([IDL.Principal], [], []),
    'set_vector_db_principal' : IDL.Func([IDL.Principal], [], []),
    'test_endpoint' : IDL.Func([IDL.Text], [IDL.Text], []),
    'update_llm_endpoint' : IDL.Func([LLMEndpoint], [], []),
  });
};
export const init = ({ IDL }) => { return []; };
